import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import * as Store from '@core/redux/stores';
import {
  AlertService,
  ConfirmModalService,
  GetOrderService,
} from '@core/services';
import { OrderDetails } from '@features/ordering/models/order-details.model';
import {
  LocationsEntity,
  IngredientsEntity,
  IngredientMultiplier,
  PickupType} from '@core/redux/stores';
import { select } from '@angular-redux/store';
import { ActivatedRoute, Params } from '@angular/router';
import * as _ from 'lodash-es';
import { OrderLineItemType, OrderTotalLineItem, ReceiptItemType } from '@app/shared/models/receipt.model';
import { Constants } from '@app/core/constants/core.constants';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.less'],
  providers: [AlertService]
})
export class OrderDetailComponent implements OnInit, OnDestroy {
  @select(appState => appState.submittedOrder)
  submittedOrder: Observable<Store.UserOrderInfo>;
  @select((appState) => appState.auth.isLoggedIn)
  isLoggedIn?: Observable<boolean>;
  protected subscriptions = new Subscription();
  protected location: Store.LocationsEntity;
  public orderDetails: OrderDetails;
  public childRecipeList: Store.MealRecipe[] = [];
  protected mealRecipe = Store.MealRecipe;
  protected childRecipesCustomization: Store.ChildRecipeEntity[] = [];
  protected child: Store.ChildRecipeEntity;
  protected ingredientList: IngredientMultiplier[] = [];
  protected ingredientsRecipe: IngredientsEntity[] = [];
  protected order: Store.UserOrderInfo;
  protected recipeId: number;
  protected childRecipeIds = '';
  protected childRecipeListDisplay: Store.MealRecipe[] = [];
  protected isUserLoggedIn: boolean;
  protected activeOrder: Store.Order;
  public isLoading: boolean;
  public isTaxIncluded: boolean;
  public OrderLineItemType = OrderLineItemType;
  constructor(
    private confirmModalService: ConfirmModalService,
    private activatedRoute: ActivatedRoute,
    private getOrderService: GetOrderService
  ) {
    this.isLoading = true;
    this.isTaxIncluded = false;
    this.submittedOrder.subscribe(succ => {
      this.order = succ as Store.UserOrderInfo;
    });
    this.isLoggedIn.subscribe(
      (auth) => {
        this.isUserLoggedIn = auth ? auth : false;
      });


  }

  ngOnInit() {
    this.subscriptions.add(
      this.activatedRoute.queryParams.subscribe(
        async (params: Params) => {
          const orderIdByparam = params[Constants.ORDER_ID];
          await this.getOrderService.getUserOrderInfo(this.isUserLoggedIn, orderIdByparam);

          this.orderDetails = <OrderDetails>this.getOrderService.orderDetails;
          this.childRecipeList = <Store.MealRecipe[]>(this.getOrderService.orderDetails as any).recipes.filter(r => r.receiptItemType !== ReceiptItemType.Fee);
          this.location = <LocationsEntity>(this.getOrderService.orderDetails as any).location;
          this.isTaxIncluded = this.getOrderService.isTaxIncluded;
          this.isLoading = false;
        }
      )
    );
  }
  isOfferItem(orderItem) {
    return orderItem && orderItem.offerId ? true : false;
  }

  isRewardItem(orderItem) {
    if (orderItem) {
      return orderItem.useReward;
    }
  }

  getRecipeName(name: string, subtitle: string) {
    const subtitleres = name ? name.replace(subtitle, '') : '';
    return name ? name.replace(subtitleres, '') : '';
  }

  getRecipeSubtitle(name: string, subtitle: string) {
    return name ? name.replace(subtitle, '') : '';
  }

  cancelOrder() {
    this.confirmModalService.show(
      'Cancel Your Order?',
      '',
      'Your order will not be made and you will not be charged.',
      'Cancel Order',
      '',
      'Keep Order',
      true,
      'cancelOrderAndEdit'
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }


}
